import {useEffect, useState} from 'react';
import {IonLabel, IonTextarea} from '@ionic/react';
import {useHistory, useParams} from 'react-router';
import actions from '../api/ownDeclaration';
import {validateLength} from '../utilis/validateLength';
import UIButton from '../components/UICommon/UIButton';
import UICardHeader from '../components/UICommon/UICardHeader';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UIModal from '../components/UICommon/UIModal';
import UIStackedInput from '../components/UICommon/UIStackedInput';

const EditFillTextQuestionPage: React.FC = () => {
  const [questionName, setQuestionName] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [questionOrder, setQuestionOrder] = useState<number>();
  const [questionContentId, setQuestionContentId] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [questionErrors, setQuestionErrors] = useState({
    questionName: '',
    title: '',
    content: '',
  });
  const history = useHistory();
  const {id} = useParams<any>();

  // eslint-disable-next-line max-len
  const desc = 'Här kan du skapa ett fält i hälsodeklarationen där kund får fylla i text. Välj vilken rubrik du vill ha och sedan en beskrivning som visas innan fylla i text fältet.';

  useEffect(() => {
    if (id != null) {
      setLoading(true);
      actions.fetchOwnQuestion(id)
          .then((res: any) => {
            setQuestionName(res?.data?.title);
            setTitle(res?.data?.question_content[0]?.name);
            setContent(res?.data?.question_content[0]?.text);
            setQuestionContentId(res?.data?.question_content[0]?.id);
            setQuestionOrder(res?.data?.order);
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
            setError(true);
          });
    }
  }, []);

  const onSubmit = () => {
    const tmpErrors = {
      questionName: validateLength(questionName),
      title: validateLength(title),
      content: validateLength(content),
    };
    setQuestionErrors(tmpErrors);
    const hasErrors = Object.values(tmpErrors).some((error) => error !== '');
    if (!hasErrors) {
      setLoading(true);
      const data = {
        title: questionName,
        type: 'fill',
        question_content: [
          {
            id: questionContentId,
            name: title,
            text: content,
            order: 0,
          },
        ],
        order: questionOrder,
      };
      actions.editOwnQuestion(data, id).then(() => {
        setLoading(false);
        history.push('/egen-deklaration');
      }).catch(() => {
        setLoading(false);
        setError(true);
      });
    }
  };

  const onDelete = (id: number) => {
    setLoading(true);
    actions.deleteOwnQuestion(id).then(() => {
      setLoading(false);
      history.push('/egen-deklaration');
    }).catch(() => {
      setLoading(false);
      setError(true);
    });
  };

  return loading ? <UIModal message='Läser in...'/> : error ? <UIErrorIndicator/> : (
    <div className='mt-5 flex h-full pb-10 px-6 flex-col'>
      <div
        className='text-center py-1 rounded-7 text-xs bg-gray-200 w-20 mb-3 text-navy-primary'>
          Fylla i text
      </div>
      <UICardHeader
        title='Nytt fylla i text fält'
        description={desc}
        longer={true}
        padding={false}
      />
      <div className='max-w-[600px] h-full flex flex-col space-y-4'>
        <div>
          <UIStackedInput
            labelText='Namn på fält (detta är endast synligt för dig)'
            text={questionName}
            setText={setQuestionName}
            placeholder='exempel: Läkiningsprocess steg 1'
            textStyle='font-medium'
            style='rounded-md border-neutral-200'
          />
          {questionErrors.questionName.length > 0 && (
            <span className='text-sm text-red-form'>{questionErrors.questionName}</span>
          )}
        </div>
        <div>
          <UIStackedInput
            labelText='Rubrik'
            text={title}
            setText={setTitle}
            placeholder='exempel: Läkiningsprocess'
            textStyle='font-medium'
            style='rounded-md border-neutral-200'
          />
          {questionErrors.title.length > 0 && (
            <span className='text-sm text-red-form'>{questionErrors.title}</span>
          )}
        </div>
        <div className='flex-grow'>
          <IonLabel
            position="stacked"
            className='text-sm font-Manrope font-medium text-navy-black'
          >Beskrivning</IonLabel>
          <IonTextarea
            placeholder='Vad som ska stå som beskriving...'
            className='border w-full h-full rounded text-sm textarea-c'
            value={content}
            onIonChange={(e) => setContent(e.detail.value!)}
          ></IonTextarea>
          {questionErrors.content.length > 0 && (
            <span className='text-sm text-red-form'>{questionErrors.content}</span>
          )}
        </div>
      </div>
      <div className='flex justify-center md:justify-end max-w-[600px] py-10'>
        <UIButton
          type='full'
          onClick={() => onDelete(id)}
          text='Ta bort fält'
          style='w-36 orange-background round-10 mr-5'
        />
        <div>
          <UIButton type='full' style='round-10' onClick={onSubmit} text='Spara som färdig'/>
        </div>
      </div>
    </div>
  );
};

export default EditFillTextQuestionPage;
